module.exports = __webpack_public_path__ + "static/img/certificate_img21.cf9e11f0.jpg";